// These error codes are from the engine exception table, do not change
export const connectorHttpErrorErrorCode = 404075;
export const variableInvalidValueErrorCode = 403032;
